import { call, put, takeLatest } from 'redux-saga/effects'

import { getContexts } from '@galo-monitor/services/apis/galoMonitorApi/resources/session'

import { FarmActions } from '../farm'
import { PropertyActions } from '../property'
import { ContextActions, ContextTypes } from './duckContext'

function* loadContexts() {
  const { data: contexts } = yield call(getContexts)
  yield put(ContextActions.loadContextsSuccess(contexts))
}

function* initContextById({ contextId }) {
  switch (contextId) {
    case 1: // root
      yield put(ContextActions.initContextRoot())
      break
    case 2: // company
      yield put(ContextActions.initContextCompany())
      break
    case 3: // farm
      yield put(ContextActions.initContextFarm())
      break
    default: // insert your context here
      break
  }
}

function* initContextCompany() {
  yield put(FarmActions.resetCurrentFarm())
  yield put(PropertyActions.resetCurrentProperty())
}

function* initContextFarm() {
  yield put(PropertyActions.resetCurrentProperty())
}

export default [
  takeLatest(ContextTypes.LOAD_CONTEXTS, loadContexts),
  takeLatest(ContextTypes.INIT_CONTEXT_BY_ID, initContextById),
  takeLatest(ContextTypes.INIT_CONTEXT_COMPANY, initContextCompany),
  takeLatest(ContextTypes.INIT_CONTEXT_FARM, initContextFarm)
]
